var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.688965 7C1.2373 4.01333 3.85472 1.75 7.00005 1.75C10.1454 1.75 12.7622 4.01333 13.3111 7C12.7628 9.98667 10.1454 12.25 7.00005 12.25C3.85472 12.25 1.23788 9.98667 0.688965 7ZM7.00005 9.91667C7.7736 9.91667 8.51546 9.60938 9.06244 9.06239C9.60942 8.51541 9.91672 7.77355 9.91672 7C9.91672 6.22645 9.60942 5.48459 9.06244 4.93761C8.51546 4.39062 7.7736 4.08333 7.00005 4.08333C6.2265 4.08333 5.48463 4.39062 4.93765 4.93761C4.39067 5.48459 4.08338 6.22645 4.08338 7C4.08338 7.77355 4.39067 8.51541 4.93765 9.06239C5.48463 9.60938 6.2265 9.91667 7.00005 9.91667ZM7.00005 8.75C6.53592 8.75 6.0908 8.56563 5.76261 8.23744C5.43442 7.90925 5.25005 7.46413 5.25005 7C5.25005 6.53587 5.43442 6.09075 5.76261 5.76256C6.0908 5.43437 6.53592 5.25 7.00005 5.25C7.46418 5.25 7.9093 5.43437 8.23749 5.76256C8.56567 6.09075 8.75005 6.53587 8.75005 7C8.75005 7.46413 8.56567 7.90925 8.23749 8.23744C7.9093 8.56563 7.46418 8.75 7.00005 8.75Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.688965,
    y1: 1.75,
    x2: 13.3587,
    y2: 2.05639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED456C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A362"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeFill);
export default __webpack_public_path__ + "static/media/eye-fill.7e46aedd.svg";
export { ForwardRef as ReactComponent };